import { useEffect } from "react";
import { NaeSSchemaMap } from '../../_custom/config/NaeSSchema';
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorReferencePeriodNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IReferencePeriodModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const IReferencePeriodFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useReferencePeriodHookNae(id: number) : IReferencePeriodModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorReferencePeriodNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.ReferencePeriod.schema,
        fields: IReferencePeriodFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
